import { isEqual } from 'lodash';

export const constants = {
    KEYS: {
      BACKSPACE: 8,
      DEL: 46,
      UP: 38,
      DOWN: 40,
      ENTER: 13,
      ESC: 27,
      SPACE: 32,
      TAB: 9,
      SHIFT: 16
    },
    ACTIONS: {
      LengthGreaterThan: (text, value) => text.length > value,
      LengthSmallerThan: (text, value) => text.length < value,
      Equal: (text, value) => isEqual(text, value),
      NotEqual: (text, value) => !isEqual(text, value)
    }
  };
